module.exports = __webpack_public_path__ + "static/media/origami3.b1f1eb84.jpg";